import { render, staticRenderFns } from "./SignUpDetails2.vue?vue&type=template&id=638e7ba0&scoped=true&"
import script from "./SignUpDetails2.vue?vue&type=script&lang=js&"
export * from "./SignUpDetails2.vue?vue&type=script&lang=js&"
import style0 from "./SignUpDetails2.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SignUpDetails2.vue?vue&type=style&index=1&id=638e7ba0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638e7ba0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAvatar,VBtn,VCol,VIcon,VImg,VRow,VTextField})
